// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"br-z","imageAndVideoCount":"cr-z","imageAndVideoContainer":"dr-z","viewAllReviews":"er-z"};